<template>
  <div class="box">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>
    <!-- 右边内容 -->
    <div class="content-right">
      <!-- 标题 个人中心 -->
      <p class="person-title">我的图书</p>
      <!-- 主要内容 -->
      <!-- <div class="content-main"> -->
      <!-- <div class="box-title">
        <p>名称</p>
        <p>日期</p>
        <p>结果</p>
      </div> -->
      <div v-if="mydata.userBookArr.length === 0">
        <p
          style="
            line-height: 300px;
            text-align: center;
            letter-spacing: 1px;
            color: #999999;
          "
        >
          暂无图书
        </p>
      </div>
      <div class="box-big" v-else>
        <div
          class="box-item"
          v-for="(item, index) in mydata.userBookArr"
          :key="index"
        >
          <p>{{ item.book_title }}</p>
          <p>
            <span>
              日期：
              {{ item.create_time.slice(0, 10) }}
            </span>
            <!-- <p>
            {{ item.data }}
            <span>{{ item.time }}</span>
            </p> -->
            <span>已验证</span>
            <!-- <p v-if="item.result === 1">已验证 </p>
            <p v-else style="color:red">查询失败</p> -->
          </p>
        </div>
      </div>
      <!--分页 -->
      <div class="gl-pagination">
        <el-pagination
          v-model:currentPage="mydata.pageObj.currentPage"
          v-model:page-size="mydata.pageObj.pageSize"
          :total="mydata.pageObj.total"
          layout="prev, pager, next"
        pager-count="4"
          @current-change="handleCurrentChange"
        />
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>








<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import { useRouter, useRoute } from "vue-router";

import { reactive, computed, toRefs } from "vue";

// import { ElMessage } from 'element-plus'
// import { ComponentSize, FormInstance, FormRules } from "element-plus";

// import {
//   Delete,
//   Download,
//   Plus,
//   ZoomIn,
//   Warning,
// } from "@element-plus/icons-vue";

// import { UploadFile } from "element-plus";

import dayjs from "dayjs";

// 引入我的图书接口
import { userBookList } from "@/api/personalCenter/myBook/index.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  size: "default",

  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,

  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  sizeList: ["small"],

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 10, // 每页条数
    total: 0, // 总的条数
  },

  userBookArr: [], //用户活动列表

  // list: [
  //   {
  //     id: 1,
  //     user_id: 3,
  //     book_id: 95,
  //     book_title: "图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称图书名称",
  //     verify_code: 287379,
  //   },
  //   {
  //     id: 1,
  //     user_id: 3,
  //     book_id: 95,
  //     book_title: "图书名称",
  //     verify_code: 287379,
  //   },

  // ],
});

const { circleUrl, sizeList } = toRefs(mydata);

const props = defineProps({
  ulLi: {
    type: Array,
    default: () => {
      return [
        {
          title:
            "浙江省高考模拟试题汇编浙江省高考模拟试题汇编浙江省高考模拟试题汇编",
          data: "2024-13-15",
          time: "11:35:08",
          no_collect: "已验证",
        },
        {
          title:
            "浙江省高考模拟试题汇编浙江省高考模拟试题汇编浙江省高考模拟试题汇编",
          data: "2024-13-15",
          time: "11:35:08",
          no_collect: "已验证",
        },
        {
          title:
            "浙江省高考模拟试题汇编浙江省高考模拟试题汇编浙江省高考模拟试题汇编",
          data: "2024-13-15",
          time: "11:35:08",
          no_collect: "已验证",
        },
        {
          title:
            "浙江省高考模拟试题汇编浙江省高考模拟试题汇编浙江省高考模拟试题汇编",
          data: "2024-13-15",
          time: "11:35:08",
          no_collect: "已验证",
        },
        {
          title:
            "浙江省高考模拟试题汇编浙江省高考模拟试题汇编浙江省高考模拟试题汇编",
          data: "2024-13-15",
          time: "11:35:08",
          no_collect: "已验证",
        },
        {
          title:
            "浙江省高考模拟试题汇编浙江省高考模拟试题汇编浙江省高考模拟试题汇编",
          data: "2024-13-15",
          time: "11:35:08",
          no_collect: "已验证",
        },
        {
          title:
            "浙江省高考模拟试题汇编浙江省高考模拟试题汇编浙江省高考模拟试题汇编",
          data: "2024-13-15",
          time: "11:35:08",
          no_collect: "查询失败",
        },
        {
          title:
            "浙江省高考模拟试题汇编浙江省高考模拟试题汇编浙江省高考模拟试题汇编",
          data: "2024-13-15",
          time: "11:35:08",
          no_collect: "已验证",
        },
      ];
    },
  },
});

// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  userBookFn();
}

// 获取我的图书列表
function userBookFn() {
  userBookList(mydata.userInfo.jwt, {
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 我的图书
    // console.log(res.data.list,"我的图书")
    mydata.userBookArr = res.data.list;
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}

// 查询
userBookFn();
</script>












<style scoped lang="scss">
////右边内容
.box {
  .content-right {
    // width: 950px;
    // height: 784px;
    background-color: #ffffff;
    // border:1px solid rgb(0, 255, 34);
    // padding-left: 62px;
    // position: relative;
    margin-top: 16px;
    overflow: hidden;
    // padding-bottom:40px;

    //标题 我的图书
    .person-title {
      font-size: 16px;
      font-weight: 700;
      color: #282828;
      letter-spacing: 1px;
      line-height: 54px;
      padding: 0px 16px;
      border-bottom: 2px solid #e4e7ed;

      // margin-bottom: 10px;
    }

    //主要内容

    //装每条的大盒子
    .box-big {
      width: 343px;
      min-height: 500px;
      margin: 0 auto;
      // border: 1px solid red;
      overflow: hidden;
      ////每一条
      .box-item {
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // align-items: center;
        // padding: 0px 43px 0px 19px;
        // margin-bottom: 20px;
        // position: relative;
        border-bottom: 1px solid #dcdee2;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        padding: 16px 0px 10px 0px;
        > p:nth-of-type(1) {
          // width: 343px;
          height: 44px;
          // border:1px solid rgb(0, 255, 85);
          line-height: 22px;
          // cursor: pointer;
          display: -webkit-box;
          -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
          text-overflow: ellipsis; //文本溢出 用省略号显示
          -webkit-line-clamp: 2; //几行
          overflow: hidden;
        }
        > p:nth-of-type(2) {
          // width: 168px;
          // margin-top:8px;
          font-size: 14px;
          // border:1px solid red;
          color: #666666;
          display: flex;
          justify-content: space-between;
          > span {
            // margin-left: 10px;
            // margin-right: 40px;
          }
        }
        // > p:nth-of-type(3) {
        //   width: 80px;
        //   color: #666666;
        //   // border:1px solid red;
        // }
      }
      // .box-item:nth-last-of-type(1) {
      //   margin-bottom: 0px;
      // }

      .box-item:hover {
        p {
          color: #009de0;
        }
      }
    }

    //////////分页
    // .paging {
    //   // margin: 0 auto;
    //   display: flex;
    //   justify-content: center;
    //   margin-top: 40px;
    //   margin-bottom: 40px;
    //   :deep(.el-button.is-plain) {
    //     margin-left: 24px;
    //   }
    // }
    // //最左边的箭头
    // :deep(.btn-prev.is-first) {
    //   margin-right: 12px;
    //   background-color: #f5f6f7;
    // }
    // :deep(.btn-next) {
    //   background-color: #f5f6f7;
    // }
    // //每个页
    // :deep(.number) {
    //   margin-right: 12px;
    //   // color:#BBBDBF;
    //   background-color: #f5f6f7;
    // }
    // //省略号
    // :deep(.more.btn-quicknext.el-icon) {
    //   margin-right: 12px;
    //   background-color: #f9f9f9;
    // }

    // .demo-pagination-block + .demo-pagination-block {
    //   margin-top: 10px;
    // }
    // .demo-pagination-block .demonstration {
    //   margin-bottom: 16px;
    // }
  }
}
</style>